<template>
  <memlist-card>
    <div data-cy="no-permissions-alert" v-if="showNoPermissions" class="alert alert-danger" style="width: 480px;">
      <p>{{$t('ACCOUNT.NO_ACCESS_INFO1')}}</p>
      <p>{{$t('ACCOUNT.NO_ACCESS_INFO2')}}</p>
    </div>

    <div data-cy="no-permissions-alert" v-else-if="showErrorRequest" class="alert alert-danger" style="width: 480px;">
      <p>{{$t('ACCOUNT.ERROR_REQUEST1')}}</p>
    </div>

    <div v-else-if="showWarning" data-cy="warning-alert" class="alert alert-danger" role="alert" style="width: 480px;">
      {{$t('ACCOUNT.INVALID_EMAIL_PASSWORD')}}
      <button type="button" class="close" @click="showWarning = false">&times;</button>
    </div>

    <div v-else style="width: 480px;">
      <h3 class="text-center mt-4 mb-4">{{$t('ACCOUNT.LOGGING_IN')}}</h3>
    </div>

  </memlist-card>
</template>

<style lang="scss" scoped>

</style>

<script>

import dayjs from 'dayjs';
import axios from 'axios';

import { setKeyValue, getKeyValue } from '@/core/services/simpleStore';
import { mapState } from 'vuex';
import { LOGIN } from '@/core/services/store/auth.module';
import { SET_COMPANY_ID } from '@/core/services/store/common.module';
import { email, minLength, required } from 'vuelidate/lib/validators';


export default {
  name: 'EntraReturn',

  components: {
    
  },

  data() {
    return {
      error: null,
      showNoPermissions: false,
      showErrorRequest: false,
      showWarning: false,
    };
  },

  async mounted() {

    const code = this.$route.query.code;
    const client_info = this.$route.query.client_info;
    const state = this.$route.query.state;
    const session_state = this.$route.query.session_state;

    try {
      const res = await axios.post(`/entra/redirect`, {
        code, client_info, state, session_state 
      });

      if (res.status === 200) {
        
        if (res.data.selected_company_id) {
          this.$store.dispatch(SET_COMPANY_ID, res.data.selected_company_id);
        }
        this.$store.dispatch(LOGIN, {
          user: {
            user_id: res.data.id,
            email: res.data.email,
          },
          token: res.data.token,
          refresh_token: res.data.refresh_token.refresh_token,
          expires_ts: res.data.refresh_token.expires_ts
        });
        
        this.$router.push({ name: 'ml-auth-forward' });
      } else if (res.status === 403) {
        this.showNoPermissions = true;
        this.showWarning = false;
      } else if (res.status === 406) {
        this.showWarning = true;
        this.showNoPermissions = false;
      } else if (res.status === 500) {
        this.showErrorRequest = true;
        
      }
    }
    catch (err) {
      console.error('entra error', err);
      this.showErrorRequest = true;
    }

    
  },

  computed: {
    
  },

  methods: {

  }
};
</script>
